
        import * as module0 from './controllers/gallery_controller.js'
        const modules = {
            "./controllers/gallery_controller.js": module0,
        };
        export default modules;
      